import { Grid } from "@mantine/core"
import { Icons } from "src/components/ui/Icons"
import { LinkCard } from "src/components/ui/LinkCard"

export const AgencyOperationsAdminHomeLinkCards = () => {

    return (
        <Grid mt="sm">
            <Grid.Col span={12}>
                <LinkCard 
                    label="Bookings"
                    icon={Icons.booking} 
                    to={"/bookings"} 
                    color={"yellow"}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <LinkCard 
                    label="Venues"
                    icon={Icons.venue} 
                    to={"/venues"} 
                    color={"green.8"}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <LinkCard 
                    label="Talent"
                    icon={Icons.talent} 
                    to={"/talent"} 
                    color={"blue.6"}
                />
            </Grid.Col>
        </Grid>
    )
}